import React from "react"
import Multiselect from "multiselect-react-dropdown"
import { RegionalPartner } from "../Interfaces/RegionalPartner"
import GetCantonName from "../Utils/GetCantonName"
import i18n from "../i18n/config"

type Props = {
    buckets: RegionalPartner[]
    filter: string
    onSelect: (selectList: any[], selectedItem: any) => void
    onRemove: (selectList: any[], selectedItem: any) => void
}

class SelectFilter extends React.Component<Props, any> {
    getSortedBuckets() {
        const { buckets, filter } = this.props

        if (filter === 'canton') {
            return [...buckets].sort((a, b) => {
                const nameA = GetCantonName(a.key).toLowerCase()
                const nameB = GetCantonName(b.key).toLowerCase()
                return nameA.localeCompare(nameB)
            })
        }

        return buckets
    }

    render() {
        const sortedBuckets = this.getSortedBuckets()

        return (
            <div className="filter">
                <label className="filter-title">{i18n.t(this.props.filter)}</label>

                <Multiselect
                    id={this.props.filter}
                    options={sortedBuckets}
                    displayValue="key"
                    placeholder={
                        this.props.filter === 'offers'
                            ? i18n.t('offersPlaceholder')
                            : i18n.t('canton')
                    }
                    hidePlaceholder={true}
                    avoidHighlightFirstOption={true}
                    showArrow={true}
                    showCheckbox={true}
                    optionValueDecorator={(v: string, option: any) => {
                        let value = ''
                        this.props.filter === 'canton'
                            ? (value = `${GetCantonName(v)} (${option.doc_count})`)
                            : (value = `${v} (${option.doc_count})`)
                        return value
                    }}
                    selectedValueDecorator={(v: string, option: any) => {
                        let value = ''
                        this.props.filter === 'canton'
                            ? (value = GetCantonName(v))
                            : (value = v)
                        return value
                    }}
                    onSelect={this.props.onSelect}
                    onRemove={this.props.onRemove}
                />
            </div>
        )
    }
}

export default SelectFilter
